export function normaliseInstructions(instructions: string): string | null {
  const trimmed = instructions.trim();
  return trimmed.length === 0 ? null : trimmed;
}
